
import { Container,Row,Col } from "react-bootstrap";
import Shopintegrate from "../../components/shop_integrate";


const Transportintegrate=()=>{

return(<>
<Container>
    <div className="screenHeight">
<Shopintegrate newshop="/create-transport" url="/transport-integrate-form"/>
    </div>
</Container>

</>)

}

export default Transportintegrate